var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('div',{class:'nav-' + _vm.navType,attrs:{"id":"LoggedIn"}},[_c('div',{ref:"logged_in",staticClass:"theme position-relative d-flex"},[_c('div',{staticClass:"main position-relative"},[_c('SideFeedbackButton'),_c('div',{staticClass:"main-inner bg-white",class:{
          'no-side-bar': !_vm.showSideBar,
          'limit-scroll': _vm.isOverlayVisible
        }},[_c('Header',{attrs:{"isLightTheme":_vm.isLightTheme}}),_c('ContentRouter'),_c('Footer',{attrs:{"isLightTheme":_vm.isLightTheme}})],1)],1)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }